
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enterprise-shipping",
      function () {
        return require("private-next-pages/enterprise-shipping.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enterprise-shipping"])
      });
    }
  